import { Button, Typography } from 'antd';
import { useNavigate } from 'react-router-dom';

import styles from './index.module.css';

const { Title, Text } = Typography;

const src = `${process.env.PUBLIC_URL}/images/404.svg`;

/**
 * The button navigates itself. It used to wrap a <Link>, a link inside a
 * button: two tab stops for one action, and Enter on the focused button did
 * nothing, because only the link inside it navigated.
 */
const NotFound = () => {
  const navigate = useNavigate();
  return (
    <div className={styles.wrapper}>
      <img src={src} className={styles.img} alt="" />
      <Title level={3}>Page not found</Title>
      <Text type="secondary" className={styles.desc}>
        The link may be wrong, or the page may have moved.
      </Text>
      <Button type="primary" onClick={() => navigate('/jobs')}>
        Go to job list
      </Button>
    </div>
  );
};

export default NotFound;
